import { root } from './autocrop';

export const autocrop = {
  ...root,
};
